import { TypesHelper } from "c4u-web-components";
import { PaymentMethodEnum } from "../../enums/payment-method.enum";

export interface IPostPacksRequest {
  expiration: string;
  cardholder: string;
  cardNumber: string;
  cvv: string;
  packId: number;
  dueDate: Date | null;
  operationType: PaymentMethodEnum;
  value: number;
}

export interface IPostPackResponse {
  result: boolean;
  bankSlipURL?: string;
}

export class PostPacksRequest {
  expiration: string | null;
  cardholder: string | null;
  cardNumber: string | null;
  cvv: string | null;
  packId: number | null;
  dueDate: Date | null;
  operationType: PaymentMethodEnum;
  value: number | null;

  constructor({
    packId,
    cvv,
    cardholder,
    expiration,
    cardNumber,
    dueDate,
    operationType,
    value
  }: IPostPacksRequest) {
    this.packId = TypesHelper.toNumberNull(packId);
    this.cvv = TypesHelper.toStringNull(cvv);
    this.cardholder = TypesHelper.toStringNull(cardholder);
    this.expiration = TypesHelper.toStringNull(expiration);
    this.cardNumber = TypesHelper.toStringOnlyNumbersNull(cardNumber);
    this.dueDate = TypesHelper.toDateNull(dueDate);
    this.operationType = TypesHelper.toNumberNull(operationType) as PaymentMethodEnum;
    this.value = TypesHelper.toNumberNull(value);
  }
}

export interface ICreditAcquisitionForm
  extends Omit<IPostPacksRequest, "packId" | "operationType" | "value"> {}
